import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Instagram: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="instagram" transform="translate(-1.5 -1.5)">
                <path
                    id="Path_794"
                    data-name="Path 794"
                    d="M18,10.5A7.5,7.5,0,1,0,25.5,18,7.5,7.5,0,0,0,18,10.5ZM13.5,18A4.5,4.5,0,1,0,18,13.5,4.5,4.5,0,0,0,13.5,18Z"
                    fill="#fff"
                    fillRule="evenodd"
                />
                <path
                    id="Path_795"
                    data-name="Path 795"
                    d="M27,7.5A1.5,1.5,0,1,0,28.5,9,1.5,1.5,0,0,0,27,7.5Z"
                    fill="#fff"
                />
                <path
                    id="Path_796"
                    data-name="Path 796"
                    d="M7.5,1.5a6,6,0,0,0-6,6v21a6,6,0,0,0,6,6h21a6,6,0,0,0,6-6V7.5a6,6,0,0,0-6-6Zm21,3H7.5a3,3,0,0,0-3,3v21a3,3,0,0,0,3,3h21a3,3,0,0,0,3-3V7.5A3,3,0,0,0,28.5,4.5Z"
                    fill="#fff"
                    fillRule="evenodd"
                />
            </g>
        </svg>
    );
};

export default React.memo(Instagram);
